import { ComponentProps, RefObject } from "react";
import { ResizeHandlerDirection } from "store/features/memeGenerator/types";
import { useResizeHandler } from "./useResizeHandler";

interface ResizeHandlerProps extends ComponentProps<"div"> {
    textBoxId: string;
    direction: ResizeHandlerDirection;
    contentEditableRef: RefObject<HTMLElement>;
    textBoxContainerRef: RefObject<HTMLElement>;
}

export const ResizeHandler = ({
    textBoxId,
    direction,
    contentEditableRef,
    textBoxContainerRef,
    ...props
}: ResizeHandlerProps) => {
    const { dragHandlers } = useResizeHandler(textBoxId, direction, { contentEditableRef, textBoxContainerRef });
    return <div {...props} {...dragHandlers} />;
};
